/**
 *@author yudeping
 *下拉框控件
 */


import Component from '../../../lib/component'
import template from './select-control.html'
import {AutoSelect} from "../../util/autoSelect/autoSelect"
import {FormService} from "../../../services/formService/formService";
import WXtemplate from './select-control.wx.html'
import BaseControl from '../WXbase-control/WXbase-control';
import {AddLinkageControl} from '../add-linkage/add-linkage'
let config={
    template:template,
    actions:{
        changeOption(res){
            if( this.data.dfield && res == this.data.dfield ){
                this.data.value = [];
                this.reload();
            }
        },
	    init(){
		    let _this=this;
		    this.data.isInit=true;
		    // if(this.data.is_view){
			    for(let k in this.data.options) {
				    if(this.data.value == this.data.options[k].value) {
					    this.el.find('.dropdown').attr('title',this.data.options[k].label)
				    }
			    }
		    // }
		    if(!this.data.be_control_condition&&!this.data.unvisible) {
				this.actions.renderSelect();
		    }
		    // this.data.isInit=false;
	    },
	    renderSelect(){
	    	let dropdown=this.el.find('.dropdown');
	    	dropdown.bind('click',()=>{
			    if(this.data.is_view){
				    return;
			    }
			    dropdown.empty();
			    dropdown.removeClass('initSelect');
			    this.actions.createAutoSelect(this);
			    dropdown.unbind('click');
		    })
		    // dropdown.css('width',this.data.width?this.data.width:'250px');
		    dropdown.css('width', '258px');
		    if(this.data.is_view){
			    dropdown.css('background-color','#ebebe4');
		    }
	    	if(this.data.value){
	    		for(let item of this.data.options){
	    			if(item.value == this.data.value){
					    this.el.find('.dropdown span').text(item.label);
				    }
			    }
		    }
	    },
	    iconCheck(){
		    if(!this.data.is_view && this.data.can_add_item){
			    this.el.find('.add-item').css('visibility','visible').addClass('icon-fl')
		    }
		    if(this.data.history){
			    this.el.find('.ui-history').css('visibility','visible').addClass('icon-fl');
		    }
            if(this.data.is_linkage){
                this.el.find('.add-linkage').css('visibility','visible').addClass('icon-fl');
            }
	    },
	    createAutoSelect(_this){
		    let el=this.el.find('.dropdown');
		    let data=FormService.createSelectJson(this.data);
		    data.onSelect=this.actions.createSelectAction(_this)
		    let autoSelect=new AutoSelect({data:data});
		    this.append(autoSelect,el);
		    setTimeout(()=>{
			    autoSelect.actions.showSelectBox();
		    },0);
            this.data.isInit=false;
        },
	    createSelectAction(_this){
		    return function(data){
			    if(_this.data.isInit || !data || data.length == 0 ){
				    if(!_this.data.isInit){
					    _this.data.value='';
					    _.debounce(function(){_this.events.changeValue(_this.data)},200)();
				    }
				    return;
			    }
			    _this.data.value=data[0]['id'];
			    _.debounce(function(){_this.events.changeValue(_this.data)},200)();
		    };
	    }
    },
    binds:[
        {
            event: 'click',
            selector: '.ui-history',
            callback: function(){
                this.events.emitHistory(this.data);
            }
        },
        {
            event: 'click',
            selector: '.add-item',
            callback: function(){
                this.events.addItem(this.data)
            }
        },
        {
            event: 'click',
            selector: '.add-linkage',
            callback: function(){
                AddLinkageControl.show({
					data:this.data
				});
            }
        }
    ],
    afterRender(){
    	this.actions.iconCheck();
	    this.actions.init();
    },
    beforeDestory(){
       this.el.off();
    }
}
let SelectControl = Component.extend(config)
export default SelectControl

let WXconfig={
	data:{controlHtml:WXtemplate},
	actions:Object.assign({},config.actions,{
		createSelectAction(_this){
			return function(data){
				if(_this.data.isInit || !data || data.length == 0 ){
					if(!_this.data.isInit){
						_this.data.value='';
					}
					return;
				}
				_this.data.value=data[0]['id'];
			};
		},
		createAutoSelect(_this){
			let el=this.el.find('.dropdown');
			let data=FormService.createSelectJson(this.data);
			data.onSelect=this.actions.createSelectAction(_this);
			data.forbidSelect=true;
			let autoSelect=new AutoSelect({data:data});
			this.append(autoSelect,el);
			setTimeout(()=>{
				autoSelect.actions.showSelectBox();
			},0);
		},
	}),
	afterRender(){
		this._super.afterRender();
		this.actions.init();
		this.actions.createAutoSelect();
	}
}
let SelectControlWX=BaseControl.extend(WXconfig);
export {SelectControlWX}


// WEBPACK FOOTER //
// app/components/form/select-control/select-control.js